import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {mobile} from '../../../const/sizes';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: `0 ${mobile.contentLargerSpacing}`,
        },
        header: {
            fontSize: 36,
            fontWeight: 'bold',
            marginTop: 32,
            marginBottom: 32,
        },
        information: {
            width: '100%'
        },
        image: {
            width: '30%',
            marginTop: 60,
            marginBottom: 60,
            margin: '0 auto',
            display: 'inline-block'
        },
        button: {
            width: '100%',
            marginBottom: 66,
        },
        [theme.breakpoints.up('md')]: {
            container: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
            header: {
                marginTop: 64,
                marginBottom: 32,
            },
            information: {
                textAlign: 'center',
            },
            image: {
                width: 200,
            },
            button: {
                width: 300,
                marginBottom: 66,
            },
        },
    }),
);

export default useStyles;
